import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Shadcn/ui 标准 cn() helper · 合并 className 时去重 Tailwind 类 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
